import { AiseaApiFactory } from "@/api/aisea/apiFactory";

const crewFiscalYearSummariesRepository = AiseaApiFactory.get(
  "enterpriseCrewFiscalYearSummaries"
);
const enterpriseCrewsFiscalYeatDefaultsRepository = AiseaApiFactory.get(
  "enterpriseCrewsFiscalYeatDefaults"
);
const enterpriseCrewsRolesRepository = AiseaApiFactory.get(
  "enterpriseCrewsRoles"
);
const enterpriseCrewFiscalYearsRepository = AiseaApiFactory.get(
  "enterpriseCrewFiscalYears"
);

const CrewAssignmentManagementService = {
  async fetchFiscalYearDefaults() {
    const res = await enterpriseCrewsFiscalYeatDefaultsRepository.fetch();
    if (!res || !res.status) {
      throw res;
    }
    return res;
  },
  async fetchCrewRoles() {
    const res = await enterpriseCrewsRolesRepository.fetch();
    if (!res || !res.status) {
      throw res;
    }
    return res;
  },
  async fetchCrewFiscalYearSummaries(fiscalYear) {
    if (fiscalYear === undefined || fiscalYear === null || fiscalYear === "") {
      return Promise.resolve({
        status: true,
        data: { crew_fiscal_year_summaries: [] },
      });
    }
    const res = await crewFiscalYearSummariesRepository.fetch(fiscalYear);
    if (!res || !res.status) {
      throw res;
    }
    return res;
  },
  async updateCrewFiscalYear(
    enterpriseCrewId,
    enterpriseCrewFiscalYearId,
    payload
  ) {
    const response = await enterpriseCrewFiscalYearsRepository.update(
      enterpriseCrewId,
      enterpriseCrewFiscalYearId,
      payload
    );
    if (!response || !response.status) {
      throw response;
    }
    return response;
  },
};

export default CrewAssignmentManagementService;
